import React, {Component} from 'react'
import Pricing from "./Pricing";
import Footer from "./Footer";
import Organizatorzy from "./Organizatorzy";
import Sponsorzy from "./Sponsorzy";
import baner from './assets/pw_data/baner_jasny.png'
import Patronaty from "./Patronaty";

export default class Kongres extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <>
        <Baner/>
        <NaszeCele/>
        <PaneleTematyczne/>
        <AgendaKongres/>
        <Pricing/>
        <Patronaty/>
        <Organizatorzy data={this.props.data}/>
        <Sponsorzy data={this.props.data}/>
        <Footer/>
      </>
    );
  }
}

function NaszeCele() {
  return (
    <div className="bg-gray-800 text-gray-100">
      <div className="px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-extrabold sm:text-4xl">KONGRES MŁODYCH
            NAUKOWCÓW</h2>
          <p className="mt-4 text-lg text-bezowyPW">Nasze cele</p>
        </div>
        <dl
          className="mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
          <div className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                 aria-hidden="true" className="flex-shrink-0 w-6 h-6 text-violet">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <div className="ml-3">
              <dt className="text-lg font-medium text-bezowyPW">Konsolidacja współpracy w zakresie nauki, gospodarki,
                kultury
                pomiędzy Politechniką Warszawską reprezentowaną przez kadrę, a specjalistami wielu dziedzin
                uczestniczącymi w wydarzeniach
              </dt>
            </div>
          </div>
          <div className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                 aria-hidden="true" className="flex-shrink-0 w-6 h-6 text-violet">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <div className="ml-3">
              <dt className="text-lg font-medium text-bezowyPW">Prezentacja wizerunku Młodych Naukowców Politechniki
                Warszawskiej
                oraz budowanie obszarów współpracy z podmiotami zewnętrznymi.
              </dt>
            </div>
          </div>
          <div className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                 aria-hidden="true" className="flex-shrink-0 w-6 h-6 text-violet">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <div className="ml-3">
              <dt className="text-lg font-medium text-bezowyPW">Promocja środowiska naukowego Politechniki Warszawskiej
                i stworzenie wspólnej platformy do konfrontacji myśli i wymiany
                poglądów.
              </dt>
            </div>
          </div>
          <div className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                 aria-hidden="true" className="flex-shrink-0 w-6 h-6 text-violet">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <div className="ml-3">
              <dt className="text-lg font-medium text-bezowyPW ">Popularyzacja Nauki na Politechnice Warszawskiej wśród
                społeczności
                akademickiej, dzięki wspólnej wystawie posterów przygotowanych przez studentów, doktorantów,
                asystentów i adiunktów Politechniki Warszawskiej.
              </dt>
            </div>
          </div>
        </dl>
      </div>
    </div>
  )
}

function AgendaKongres() {
  return (
    <section className=" text-greenPW">
      <div className="container max-w-5xl px-4 py-12 mx-auto">
        <div className="grid gap-4 mx-4 sm:grid-cols-12">
          <div className="col-span-12 sm:col-span-3">
            <div
              className="text-center sm:text-left mb-14 before:block before:w-24 before:h-3 before:mb-5 before:rounded-md before:mx-auto sm:before:mx-0 before:bg-violet">
              <h3 className="text-3xl font-semibold">Agenda Kongresu</h3>
            </div>
          </div>
          <div className="relative col-span-12 px-4 space-y-6 sm:col-span-9">
            <div
              className="col-span-12 space-y-12 relative px-4 sm:col-span-8 sm:space-y-8 sm:before:absolute sm:before:top-2 sm:before:bottom-0 sm:before:w-0.5 sm:before:-left-3 before:bg-gray-700">
              <div
                className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:bg-violet">
                <h3 className="text-xl font-semibold tracking-wide">Rejestracja</h3>
                <time className="text-xs tracking-wide uppercase text-gray-400">9:30 - 10:00</time>
              </div>
              <div
                className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:bg-violet">
                <h3 className="text-xl font-semibold tracking-wide">Oficjalne rozpoczęcie</h3>
                <time className="text-xs tracking-wide uppercase text-gray-400">10:00 - 10:20</time>
              </div>
              <div
                className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:bg-violet">
                <h3 className="text-xl font-semibold tracking-wide">Panel nr 1</h3>
                <time className="text-xs tracking-wide uppercase text-gray-400">10:20 11:30</time>
              </div>
              <div
                className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:bg-violet">
                <h3 className="text-xl font-semibold tracking-wide">Przerwa Kawowa</h3>
                <time className="text-xs tracking-wide uppercase text-gray-400">11:30 11:45</time>
              </div>
              <div
                className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:bg-violet">
                <h3 className="text-xl font-semibold tracking-wide">Panel nr 2</h3>
                <time className="text-xs tracking-wide uppercase text-gray-400">11:45 13:00</time>
              </div>
              <div
                className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:bg-violet">
                <h3 className="text-xl font-semibold tracking-wide">Rozdanie nagród w konkursie na poster naukowy</h3>
                <time className="text-xs tracking-wide uppercase text-gray-400">13:30 13:40</time>
              </div>
              <div
                className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:bg-violet">
                <h3 className="text-xl font-semibold tracking-wide">Lunch</h3>
                <time className="text-xs tracking-wide uppercase text-gray-400">13:00 13:30</time>
              </div>
              <div
                className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:bg-violet">
                <h3 className="text-xl font-semibold tracking-wide">Panel nr 3</h3>
                <time className="text-xs tracking-wide uppercase text-gray-400">13:40 14:40</time>
              </div>
              <div
                className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:bg-violet">
                <h3 className="text-xl font-semibold tracking-wide">Zakończenie kongresu</h3>
                <time className="text-xs tracking-wide uppercase text-gray-400">14:50</time>
              </div>
              <div
                className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:bg-violet">
                <h3 className="text-xl font-semibold tracking-wide">Oficjalnie rozpoczęcie Balu Młodych Naukowców</h3>
                <time className="text-xs tracking-wide uppercase text-gray-400">19:00</time>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function PaneleTematyczne() {
  return (
    <section className="py-20 bg-greenPW text-gray-100">
      <div className="container px-4 mx-auto">
        <div>
          <h2 className="text-3xl font-bold tracking-tight text-center sm:text-5xl text-bezowyPW">Panele
            tematyczne</h2>
          <p className="max-w-3xl mx-auto mb-9 mt-12 text-xl text-center text-bezowyPW">Kongres Młodych Naukowców to
            możliwość
            uczestnictwa w dyskusji nad aktualnymi problemami rozwoju teorii i praktyki w ramach wskazanych obszarów
            tematycznych.</p>
        </div>
        <div className="flex flex-wrap items-stretch -mx-4">
          <div className="flex w-full mb-8 sm:px-4 md:w-1/2 lg:w-1/3 lg:mb-0">
            <div className="flex flex-col p-6 space-y-6 rounded  sm:p-8 bg-bezowyPW">
              <div className="space-y-2">
                <h4 className="text-2xl font-bold text-greenPW">Młodzi Naukowcy</h4>
              </div>
              <p className="mt-3 leading-relaxed text-greenPW text-xl">Panel poświęcony zagadnieniom związanym z
                funkcjonowaniem, problematyką i możliwościami wynikającymi z podejmowanych trudów Młodych Naukowców.
              </p>
              <ul className="flex-1 mb-6 text-greenPW">
                <li className="flex mb-2 space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                       className="flex-shrink-0 w-6 h-6 text-violet">
                    <path fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"></path>
                  </svg>
                  <span>Płaszczyzna wymiany myśli środowisk patrzących na Młodych Naukowców z różnych perspektyw. </span>
                </li>
                <li className="flex mb-2 space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                       className="flex-shrink-0 w-6 h-6 text-violet">
                    <path fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"></path>
                  </svg>
                  <span>Stworzenie
                płaszczyzn komunikacji międzybranżowej odpowiadającej na potrzeby i wyzwania Młodej kadry naukowej. </span>
                </li>
                <li className="flex mb-2 space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                       className="flex-shrink-0 w-6 h-6 text-violet">
                    <path fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"></path>
                  </svg>
                  <span>W
                Panelu wezmą udział m.in. przedstawiciele Władz Uczelni oraz Rady Uczelni, Dyrektor Szkoły Doktorskiej
                PW, Młodzi Naukowcy, ekspert z dziedziny prawa własności intelektualnej, ekspert z Ministerstwa.</span>
                </li>
              </ul>
              <div
                className="inline-block px-5 py-3 font-semibold tracking-wider text-center rounded bg-orangePW text-greenPW">
                <a rel="noopener noreferrer" href="#"
                   className="px-8 py-3 text-lg font-semibold rounded bg-orangePW text-gray-100 hover:text-violet">Więcej</a>
              </div>
            </div>
          </div>
          <div className="flex w-full mb-8 sm:px-4 md:w-1/2 lg:w-1/3 lg:mb-0">
            <div className="flex flex-col p-6 space-y-6 rounded shadow sm:p-8 bg-bezowyPW">
              <div className="space-y-2">
                <h4 className="text-2xl font-bold text-greenPW">Droga do sukcesu</h4>
              </div>
              <p className="leading-relaxed text-greenPW text-xl">Próba przedstawienia własnej definicji sukcesu Młodego
                Naukowca oraz ścieżek jego osiągnięcia.</p>
              <ul className="flex-1 mb-6 text-greenPW">
                <li className="flex mb-2 space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                       className="flex-shrink-0 w-6 h-6 text-violet">
                    <path fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"></path>
                  </svg>
                  <span> Miejsce omówienia wizji rozwoju projektów, pozyskiwania grantów,
                odnoszenia sukcesów naukowo-rozwojowych na płaszczyźnie międzynarodowej.  </span>
                </li>
                <li className="flex mb-2 space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                       className="flex-shrink-0 w-6 h-6 text-violet">
                    <path fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"></path>
                  </svg>
                  <span>Budowa usystematyzowanego
                kanonu, służącego kreowaniu drogi sukcesu w oparciu o doświadczenia i osiągnięcia Panelistów. </span>
                </li>
                <li className="flex mb-2 space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                       className="flex-shrink-0 w-6 h-6 text-violet">
                    <path fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"></path>
                  </svg>
                  <span>W Panelu
                wezmą udział m.in. przedstawiciele Władz Uczelni oraz Rady Uczelni, ekspert z Ministerstwa, Młodzi
                Naukowcy, przedstawiciele biznesu oraz przemysłu.</span>
                </li>
              </ul>
              <div
                className="inline-block px-5 py-3 font-semibold tracking-wider text-center rounded bg-orangePW text-greenPW">
                <a rel="noopener noreferrer" href="#"
                   className="px-8 py-3 text-lg font-semibold rounded bg-orangePW text-gray-100 hover:text-violet">Więcej</a>
              </div>
            </div>
          </div>
          <div className="flex w-full mb-8 sm:px-4 md:w-1/2 lg:w-1/3 lg:mb-0">
            <div className="flex flex-col p-6 space-y-6 rounded shadow sm:p-8 bg-bezowyPW">
              <div className="space-y-2">
                <h4 className="text-2xl font-bold text-greenPW">Laboratoria przyszłości</h4>
              </div>
              <p className="mt-3 leading-relaxed text-greenPW text-xl">Dyskusja na temat obecnych problemów
                występujących w procesach i aparaturze badawczej.</p>
              <ul className="flex-1 mb-6 text-greenPW">
                <li className="flex mb-2 space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                       className="flex-shrink-0 w-6 h-6 text-violet">
                    <path fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"></path>
                  </svg>
                  <span> Próba stworzenia wizji interdyscyplinarnego ośrodka
                badawczego, działającego w oparciu o najnowsze technologie, wykorzystującego inteligentne systemy
                wizualizacji podejmowanych działań naukowych. </span>
                </li>
                <li className="flex mb-2 space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                       className="flex-shrink-0 w-6 h-6 text-violet">
                    <path fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"></path>
                  </svg>
                  <span>Określenie kierunków rozwoju techniki i przemysłu w wyniku
                intensywnej rewolucji cyfrowej.  </span>
                </li>
                <li className="flex mb-2 space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                       className="flex-shrink-0 w-6 h-6 text-violet">
                    <path fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"></path>
                  </svg>
                  <span>Panelistami będą przedstawiciele Władz Uczelni, Rady Uczelni, ekspert z
                Ministerstwa, przedstawiciele biznesu i przemysłu.  </span>
                </li>
              </ul>
              <div
                className="inline-block px-5 py-3 font-semibold tracking-wider text-center rounded bg-orangePW text-greenPW">
                <a rel="noopener noreferrer" href="#"
                   className="px-8 py-3 text-lg font-semibold rounded bg-orangePW text-gray-100 hover:text-violet">Więcej</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Baner() {
  return (
    <section className="bg-gray-800 text-bezowyPW" id="baner">

      <div
        className="container mx-auto flex flex-col items-center px-4 py-16 text-center md:py-32 ">
        <img src={baner} alt="" className="object-contain sm:h-90 lg:h-106 xl:h-122 2xl:h-138"/>
        <div
          className="container mx-auto flex flex-col items-center px-30 py-16 text-center md:py-15 md:px-30 lg:px-30 xl:max-w-5xl">
          <h1 className="text-4xl font-bold leading-none sm:text-5xl">Kongres Młodych Naukowców</h1>
          <p className="mt-6 mb-8 text-lg sm:mb-12 text-bezowyPW"> Całokształt wydarzenia ma na celu promocję środowiska
            naukowego
            Politechniki Warszawskiej u potencjalnych pracodawców oraz umocnienie pozycji Uczelni i jej współpracy
            z podmiotami zewnętrznymi.
            Podczas wydarzenia, Młodzi Naukowcy z
            Politechniki Warszawskiej będą mieli
            możliwość uczestnictwa w Kongresie, gdzie będzie możliwa dyskusja nad aktualnymi problemami rozwoju
            teorii i praktyki w ramach wskazanych obszarów tematycznych.
          </p>

          <div
            className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
            <a rel="noopener noreferrer" href="#pricing"
               className="px-8 py-3 text-lg font-semibold rounded bg-orangePW text-gray-100 hover:text-greenPW">Kup
              Bilet</a>
          </div>
        </div>
      </div>
    </section>
  );
};
